import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2021-10-01T12:00",
		title: `
<h4>燕・弥彦医療介護センターより</h4>
<p class="paragraph-indent">
●つばめ・やひこ医療・福祉・介護フォーラム2021（オンライン開催）のご案内<br>
・<a href="${topicsDir}/2021/10-tsubameyahiko-forum2021.pdf">案内チラシ、申込書</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	},
	{
		date: "2021-10-20T12:00",
		title: `
<p class="paragraph-indent">
●在宅医療・介護連携推進事業/在宅医療推進センター事業　情報交換会開催のご案内<br>
参加対象：新潟県内の市町村事業担当者、在宅医療・介護連携推進事業受託先職員、在宅医療推進センターコーディネーター、地域振興局健康福祉(環境)部担当者等<br>
・<a href="${topicsDir}/2021/10-exchange-meeting2021.pdf">情報交換会案内・開催要領・申込書</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
